module.exports = __webpack_public_path__ + "img/icon-hamburger.72bac04e.svg";